import { useContext, useMemo, useEffect, useState } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import { ConfigContext } from 'contexts/ConfigContext'
import objectPath from 'object-path'
import FeatherIcon from 'feather-icons-react'
//import Select from 'react-select'
import {
  setApi,
  getServiceRequest,
  getExternalRequest,
} from '../../../action/Api'
import {
  compareTwoValue,
  getCheckValue,
  isNumber,
} from 'designer/component/action/Data'
import { FormControl, makeStyles, MenuItem, Select } from '@material-ui/core'
import { checkLockMode } from '../action/Column'

const CustomSelect = ({
  ui,
  rowData,
  onUpdateRowData,
  data,
  onUpdateData,
  isCheckDefaultValue = true,
  dataTable = [],
  fieldKey,
  fieldName,
  error,
  column,
  handleKeyDown,
}) => {
  const configContext = useContext(ConfigContext)
  const designContext = useContext(DesignContext)
  const { jsonForm } = designContext
  const { layoutType } = configContext.state
  let {
    isMulti,
    valueJoin,
    valueType,
    isAll,
    allLabel,
    allValue,
    title,
    cellStyle = {},
    isRequired,
  } = ui

  let value = data || objectPath.get(rowData, ui.field)
  const [list, setList] = useState({})
  const [options, setOptions] = useState([])
  const { optionLabel = 'label', optionValue = 'value' } = list

  const checkDisableOption = (options) => {
    if (!isCheckDefaultValue) return setOptions(options)
    let defaultValues = ui.defaultValues
    if (defaultValues) {
      defaultValues.forEach(({ include, disabled }) => {
        let isIncludeDataTable = dataTable.find((rowData) => {
          let rowValue = objectPath.get(rowData, ui.field)
          return rowValue === include
        })

        if (isIncludeDataTable) {
          options.map((option) => {
            let valueOption = objectPath.get(option, optionValue)

            if (valueOption === disabled) {
              objectPath.set(option, 'isDisabled', true)
            }
          })
        }
      })
    }
    setOptions(options)
  }

  const checkValue = (value) => {
    if (value === true) {
      return 'true'
    }
    if (value === false) {
      return 'false'
    }
    if (value === null) {
      return 'null'
    }
    if (value === undefined) {
      return 'undefined'
    }
    if (isNumber(value)) {
      return Number(value)
    }
    return value
  }

  const createOptions = (list) => {
    let options = isAll
      ? [
          {
            label: allLabel,
            [optionValue]: allValue,
            isAll: true,
          },
        ]
      : []

    if (Array.isArray(list?.options)) {
      options = options.concat(list?.options)
    }

    let { titleValue, joinTitle = '' } = list

    if (titleValue) {
      options.map((option) => {
        let titleList = []
        let labelList = []
        let fontColor = ''
        let fontWeight = ''
        let isLockedSelect
        titleValue.forEach(
          ({ title, replaceValues, fontWeight: titleFontWeight }) => {
            let itemFontColor = ''
            let itemFontWeight = titleFontWeight || ''
            let subTitle = []
            title.forEach((title) => {
              let labelValue = title.value
              let hasValue = objectPath.has(option, title.value)
              if (hasValue) {
                labelValue = objectPath.get(option, title.value)
                if (replaceValues) {
                  let foundReplace = replaceValues.find(({ value }) => {
                    let aValue = checkValue(labelValue)
                    let bValue = checkValue(value)
                    return aValue === bValue
                  })
                  if (foundReplace) {
                    let { replace } = foundReplace
                    labelValue = replace
                    itemFontColor = foundReplace.fontColor
                    itemFontWeight = foundReplace.fontWeight || titleFontWeight
                    isLockedSelect = foundReplace.isLockedSelect
                  }
                }
              }
              subTitle.push(labelValue)
            })
            let label = subTitle.join('')
            fontColor = itemFontColor || fontColor
            fontWeight = itemFontWeight || fontWeight
            titleList.push(label)
            labelList.push({
              label,
              fontColor: itemFontColor,
              fontWeight: itemFontWeight,
            })
          },
        )
        let labelValue = titleList.join(joinTitle)
        objectPath.set(option, '@isUseTitleValue', true)
        objectPath.set(option, '@label', labelValue)
        objectPath.set(option, '@labelList', labelList)
        objectPath.set(option, '@fontColor', fontColor)
        objectPath.set(option, '@fontWeight', fontWeight)
        if (isLockedSelect) {
          objectPath.set(option, 'isDisabled', fontColor)
        }
        return option
      })
    }
    checkDisableOption(options)
  }

  useEffect(async () => {
    let { optionType } = ui
    let optionData = objectPath.get(ui, `${optionType}`)
    if (optionData) {
      let { service, endpoint, pathParams, queryParams, url } = optionData
      let api = setApi(
        {
          apiType: optionType,
          service: service,
          endpoint: endpoint,
          pathParams: pathParams,
          queryParams: queryParams,
          jsonForm,
        },
        rowData,
      )
      if (optionType === 'internal') {
        if (!service || !endpoint) return
        optionData = await getServiceRequest(api, optionData, ui)
      } else if (optionType === 'external') {
        if (!url) return
        optionData = await getExternalRequest(api, optionData, ui)
      }
      createOptions(optionData)
      setList(optionData)
    }
  }, [value])

  const getOptionLabel = (option) => {
    let isUseTitleValue = objectPath.get(option, `@isUseTitleValue`)
    if (isUseTitleValue) {
      return objectPath.get(option, `@label`)
    }
    if (Array.isArray(optionLabel)) {
      let labelString = []
      let isAll = option?.isAll
      if (isAll) {
        return option?.label
      } else {
        optionLabel.forEach(({ value, __isNew__ }) => {
          if (__isNew__) {
            labelString.push(value)
          } else {
            let label = objectPath.get(option, value)
            labelString.push(label)
          }
        })
        return labelString.join('')
      }
    }
    return objectPath.get(option, optionLabel) || ''
  }

  const getOptionValue = (option) => objectPath.get(option, optionValue) || ''

  useEffect(
    () => createOptions(list),
    [list?.options, isAll, allLabel, allValue],
  )

  const checkDefaultValue = () => {
    if (!isCheckDefaultValue) return
    let defaultValues = ui.defaultValues
    if (defaultValues) {
      defaultValues.forEach(({ include, defaultValue }) => {
        if (include) {
          let isIncludeDataTable = dataTable.find((rowData) => {
            let rowValue = objectPath.get(rowData, ui.field)
            return rowValue === include
          })
          if (isIncludeDataTable) {
            objectPath.set(rowData, ui.field, defaultValue)
          }
        } else {
          objectPath.set(rowData, ui.field, defaultValue)
        }
      })
      if (onUpdateData) {
        let newValue = objectPath.get(rowData, ui.field)
        onUpdateData(newValue)
      } else if (onUpdateRowData) {
        onUpdateRowData(rowData)
      }
    }
  }

  const setValue = (value) => {
    if (isMulti && value) {
      let preview = []
      value.forEach((item) => {
        let itemValue = objectPath.get(item, optionValue)
        if (itemValue) {
          preview.push(itemValue)
        }
      })
      if (valueType === 'string') {
        return preview.join(valueJoin)
      }
      return preview
    }
    return objectPath.get(value, optionValue)
  }

  const updateData = (e) => {
    let value = e.target.value
    let option = options.find((option) => value === getOptionValue(option))
    let newValue = setValue(option)
    let { mapOther } = ui
    if (mapOther) {
      mapOther.forEach(({ field, value }) => {
        let itemValue = objectPath.get(option, value)
        objectPath.set(rowData, field, itemValue)
      })
    }
    if (onUpdateData) {
      onUpdateData(newValue)
    } else if (onUpdateRowData) {
      objectPath.set(rowData, ui.field, newValue)
      onUpdateRowData(rowData)
    }
  }

  const clearData = () => {
    let option = {}
    let newValue = ''
    let { mapOther } = ui
    if (mapOther) {
      mapOther.forEach(({ field, value }) => {
        let itemValue = objectPath.get(option, value)
        objectPath.set(rowData, field, itemValue)
      })
    }
    if (onUpdateData) {
      onUpdateData(newValue)
    } else if (onUpdateRowData) {
      objectPath.set(rowData, ui.field, newValue)
      onUpdateRowData(rowData)
    }
  }

  useEffect(() => {
    if (value === undefined) {
      checkDefaultValue()
    }
  }, [value])

  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    menuPaper: {
      maxHeight: 300,
      maxWidth: '100px',
      minWidth: '100px',
    },
  }))

  const classes = useStyles()

  let isLockEdit = checkLockMode(column, rowData)

  if (isLockEdit) {
    let found = options.find((option) =>
      compareTwoValue('equalValue', getOptionValue(option), value),
    )
    return found ? getOptionLabel(found) : ''
  }

  return (
    <FormControl size="small" error={isRequired ? error : false}>
      <div className="d-flex">
        <div>
          <Select
            style={{
              ...cellStyle,
              padding: 0,
              textAlign: 'left',
            }}
            id={fieldKey}
            value={value ?? ''}
            label={title}
            onChange={updateData}
            onKeyDown={(e) => handleKeyDown(e, rowData)}
            MenuProps={{ classes: { paper: classes.menuPaper } }}
          >
            {options.map((option) => {
              let { isDisabled } = option
              let label = getOptionLabel(option)
              let value = getOptionValue(option)
              return (
                <MenuItem value={value} disabled={isDisabled}>
                  {label}
                </MenuItem>
              )
            })}
          </Select>
        </div>
        {value && (
          <div className="pl-1">
            <FeatherIcon
              icon="x"
              size="20"
              className="add-time-button"
              onClick={clearData}
            />
          </div>
        )}
      </div>
    </FormControl>
  )
}

export default CustomSelect
